import { Form } from 'react-bootstrap';

function AdminListStatus({ selectedStatuses, status, id, onClick, type, statuslabel }) {
    const isChecked = selectedStatuses.includes(status);
    const checkboxId = `status-${statuslabel}-${id}`;
    return (
      <Form.Group controlId={id}>
        <Form.Check 
          id={checkboxId}     
          type="checkbox" 
          label={type === 'sampleRequest' ? statuslabel : (status ? "Active" : "Inactive")}
          checked={isChecked} 
          onChange={() => onClick(status)} 
        />
      </Form.Group>
    );
}

export default AdminListStatus;
